/* Sweeper Klaast landing page (sk-*): countdown, videos, gallery, size picker sync, add to cart, sticky bar */
(function () {
  if (window.__skInit) return;
  window.__skInit = true;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  var ANN_OFFSET = 52; /* height of the sticky announcement bar */

  /* ---- Countdown to a fixed date: days : hours : mins ---- */
  function initCountdown(el) {
    if (el.dataset.skReady) return;
    el.dataset.skReady = '1';
    var end = Date.parse(el.dataset.end || '');
    if (isNaN(end)) return;
    var d = qs('[data-sk-d]', el), h = qs('[data-sk-h]', el), m = qs('[data-sk-m]', el);
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0 && el.dataset.hideOnEnd === 'true') { el.hidden = true; return; }
      if (d) d.textContent = p2(Math.floor(left / 86400));
      if (h) h.textContent = p2(Math.floor((left % 86400) / 3600));
      if (m) m.textContent = p2(Math.floor((left % 3600) / 60));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Smooth scroll to the offer (below the sticky announcement bar) ---- */
  function goTo(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (qs('.sk-ann') ? ANN_OFFSET : 0);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.sk a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (id && goTo(id)) e.preventDefault();
  });

  /* ---- Videos: muted autoplay while on screen; tap tiles to play with sound ---- */
  var autoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }, { threshold: 0.15 }) : null;
  function initAutoVideo(v) {
    if (v.dataset.skReady) return;
    v.dataset.skReady = '1';
    v.muted = true;
    if (autoIO) autoIO.observe(v); else { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
  }
  function initTile(tile) {
    if (tile.dataset.skReady) return;
    tile.dataset.skReady = '1';
    var v = qs('video', tile);
    if (!v) return;
    function toggle() {
      var group = tile.closest('[data-sk-tiles]') || document;
      qsa('[data-sk-tile]', group).forEach(function (o) {
        var ov = qs('video', o);
        if (o !== tile && ov && !ov.paused) { ov.pause(); o.classList.remove('is-playing'); }
      });
      if (v.paused) {
        v.muted = false;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        tile.classList.add('is-playing');
        v.onended = function () { tile.classList.remove('is-playing'); };
      } else { v.pause(); tile.classList.remove('is-playing'); }
    }
    tile.addEventListener('click', toggle);
    tile.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  }

  /* ---- Gallery: thumbnails + arrows ---- */
  function initGallery(gal) {
    if (gal.dataset.skReady) return;
    gal.dataset.skReady = '1';
    var main = qs('.sk-gal__main > img', gal);
    var thumbs = qsa('[data-sk-th]', gal);
    var i = 0;
    function show(n) {
      if (!thumbs.length) return;
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      main.src = t.dataset.src;
      if (t.dataset.srcset) main.srcset = t.dataset.srcset; else main.removeAttribute('srcset');
      thumbs.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = qs('[data-sk-prev]', gal), next = qs('[data-sk-next]', gal);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
  }

  /* ---- Size selection shared by the Sizes section, the buy box and the sticky bar ---- */
  var picked = false;
  function buyRoot() { return qs('[data-sk-buy]'); }
  function selectOption(index, fromUser) {
    if (fromUser) picked = true;
    var root = buyRoot();
    if (root) {
      var chosen = null;
      qsa('[data-sk-opt]', root).forEach(function (o) {
        var on = Number(o.dataset.index) === index;
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.tabIndex = on ? 0 : -1;
        if (on) chosen = o;
      });
      if (chosen) {
        qsa('input[name="id"]', root).forEach(function (inp) { inp.value = chosen.dataset.variantId; });
        qsa('[data-sk-atc]', root).forEach(function (b) { b.dataset.available = chosen.dataset.available; renderAtc(b, chosen); });
      }
    }
    qsa('[data-sk-size]').forEach(function (b) { b.setAttribute('aria-pressed', Number(b.dataset.index) === index && fromUser ? 'true' : 'false'); });
    qsa('[data-sk-sizes]').forEach(function (sec) {
      if (!fromUser) return;
      var any = false;
      qsa('[data-sk-size-img]', sec).forEach(function (img) { var on = Number(img.dataset.index) === index; img.hidden = !on; if (on) any = true; });
      var def = qs('[data-sk-size-img="default"]', sec);
      if (def) def.hidden = any;
      var line = qs('[data-sk-size-line]', sec);
      var btn = qs('[data-sk-size][data-index="' + index + '"]', sec);
      if (line && btn) line.textContent = btn.dataset.line || line.dataset.default || '';
    });
    renderSticky();
  }

  function selectedOption() {
    var root = buyRoot();
    return root ? qs('[data-sk-opt][aria-checked="true"]', root) : null;
  }

  function renderAtc(btn, opt) {
    opt = opt || selectedOption();
    var label = qs('[data-sk-atc-label]', btn) || btn;
    var state = btn.dataset.state || 'idle';
    var available = !opt || opt.dataset.available !== 'false';
    btn.disabled = !available || state === 'busy';
    label.textContent = !available ? (btn.dataset.soldOut || 'Sold out') :
      state === 'busy' ? (btn.dataset.busy || 'Adding…') :
      state === 'added' ? (btn.dataset.added || 'Added ✓') :
      (btn.dataset.template || 'Add to cart · [price]').replace('[price]', opt ? opt.dataset.price : '');
  }

  /* ---- Add to cart (theme cart drawer, UpCart, or the cart page) ---- */
  function themeCart(root) {
    if (root.dataset.cartType === 'page') return null;
    var cart = qs('cart-drawer') || qs('cart-notification');
    return cart && typeof cart.renderContents === 'function' ? cart : null;
  }
  function openAppCart() {
    var hasUpcart = typeof window.upcartOpenCart === 'function' || !!window.upcartSettings;
    if (!hasUpcart) return false;
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
    } catch (err) { /* the app opens its drawer on its own after /cart/add */ }
    return true;
  }
  function addToCart(variantId, onState) {
    var root = buyRoot();
    if (!root || !variantId) return;
    var behavior = root.dataset.addBehavior || 'theme';
    var cart = behavior === 'theme' ? themeCart(root) : null;
    var payload = { id: Number(variantId), quantity: 1 };
    if (cart) {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    onState('busy');
    fetch(root.dataset.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d && (d.description || d.message) || r.status); return d; }); })
      .then(function (data) {
        onState('added');
        if (behavior === 'checkout') { window.location.href = '/checkout'; return; }
        var stay = false;
        if (cart) {
          try { cart.renderContents(data); stay = true; } catch (err) { /* fall through */ }
          var drawer = qs('cart-drawer');
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        }
        if (!stay && behavior === 'theme' && root.dataset.cartType !== 'page') stay = openAppCart();
        if (stay) { setTimeout(function () { onState('idle'); }, 2000); return; }
        window.location.href = root.dataset.cartUrl || '/cart';
      })
      .catch(function (err) {
        onState('idle', String(err.message || err));
      });
  }

  function initBuy(root) {
    if (root.dataset.skReady) return;
    root.dataset.skReady = '1';
    qsa('[data-sk-opt]', root).forEach(function (o) {
      o.addEventListener('click', function () { selectOption(Number(o.dataset.index), true); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(Number(o.dataset.index), true); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var all = qsa('[data-sk-opt]', root); var k = all.indexOf(o) + (e.key === 'ArrowDown' ? 1 : -1);
          var t = all[(k + all.length) % all.length]; selectOption(Number(t.dataset.index), true); t.focus();
        }
      });
    });
    qsa('form[data-sk-form]', root).forEach(function (form) {
      var btn = qs('[data-sk-atc]', form);
      var err = qs('[data-sk-error]', form);
      if (btn) renderAtc(btn);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!btn || btn.dataset.state === 'busy') return;
        var opt = selectedOption();
        if (err) err.hidden = true;
        addToCart(opt ? opt.dataset.variantId : qs('input[name="id"]', form).value, function (state, msg) {
          btn.dataset.state = state; renderAtc(btn);
          if (msg && err) { err.textContent = msg; err.hidden = false; }
        });
      });
    });
  }

  function initSizes(sec) {
    if (sec.dataset.skReady) return;
    sec.dataset.skReady = '1';
    qsa('[data-sk-size]', sec).forEach(function (b) {
      b.addEventListener('click', function () { selectOption(Number(b.dataset.index), true); });
    });
  }

  /* ---- Sticky bar: after the hero, hidden while the buy box is on screen ---- */
  var stkState = { heroPast: false, buyVisible: false };
  function renderSticky() {
    qsa('[data-sk-stk]').forEach(function (bar) {
      var show = stkState.heroPast && !stkState.buyVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var opt = selectedOption();
      var l1 = qs('[data-sk-stk-l1]', bar), l2 = qs('[data-sk-stk-l2]', bar), btn = qs('[data-sk-stk-btn]', bar);
      if (btn) btn.tabIndex = show ? 0 : -1;
      if (!picked || !opt) {
        if (l1) l1.textContent = bar.dataset.l1;
        if (l2) l2.textContent = bar.dataset.l2;
      } else {
        if (l1) l1.textContent = opt.dataset.name;
        if (l2) l2.textContent = opt.dataset.price;
      }
      /* The sticky button always says "Choose my size" and scrolls to the buy box */
      if (btn) btn.textContent = bar.dataset.choose;
    });
  }
  function initSticky(bar) {
    if (bar.dataset.skReady) return;
    bar.dataset.skReady = '1';
    var btn = qs('[data-sk-stk-btn]', bar);
    if (btn) btn.addEventListener('click', function () { goTo('offer'); });
    var hero = qs('[data-sk-hero]'), buy = buyRoot();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === hero) stkState.heroPast = !en.isIntersecting && en.boundingClientRect.top < 0;
          if (en.target === buy) stkState.buyVisible = en.isIntersecting;
        });
        renderSticky();
      });
      if (hero) io.observe(hero); else stkState.heroPast = true;
      if (buy) io.observe(buy);
    } else stkState.heroPast = true;
    renderSticky();
  }

  /* ---- Reviews: "Show more reviews" (mobile) ---- */
  function initMore(btn) {
    if (btn.dataset.skReady) return;
    btn.dataset.skReady = '1';
    btn.addEventListener('click', function () {
      var list = btn.closest('[data-sk-crv]');
      var open = btn.getAttribute('aria-expanded') === 'true';
      var count = parseInt(btn.dataset.count, 10) || 3;
      qsa('[data-sk-crv-item]', list).forEach(function (it, i) { it.hidden = open && i >= count; });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.textContent = open ? btn.dataset.more : btn.dataset.less;
      /* After "Show less", bring the reviews list back into view */
      if (open) {
        var r = list.querySelector('.sk-crv__r') || list;
        var top = r.getBoundingClientRect().top + window.pageYOffset - 70;
        if (r.getBoundingClientRect().top < 0) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  function init(scope) {
    qsa('[data-sk-cd]', scope).forEach(initCountdown);
    qsa('video[data-sk-auto]', scope).forEach(initAutoVideo);
    qsa('[data-sk-tile]', scope).forEach(initTile);
    qsa('[data-sk-gal]', scope).forEach(initGallery);
    qsa('[data-sk-buy]', scope).forEach(initBuy);
    qsa('[data-sk-sizes]', scope).forEach(initSizes);
    qsa('[data-sk-stk]', scope).forEach(initSticky);
    qsa('[data-sk-more]', scope).forEach(initMore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    qsa('[data-sk-atc]').forEach(function (b) { b.dataset.state = 'idle'; renderAtc(b); });
  });
})();
